export const state = [
  {
    label: 'Maharashtra',
    value: 'Maharashtra',
  },
  {
    label: 'Delhi',
    value: 'Delhi',
  },
  {
    label: 'Punjab',
    value: 'Punjab',
  },
  {
    label: 'Kerala',
    value: 'Kerala',
  },
  {
    label: 'Hyderabad',
    value: 'Hyderabad',
  },
  {
    label: 'Andhra Pradesh',
    value: 'Andhra Pradesh',
  },
  {
    label: 'Assam',
    value: 'Assam',
  },
  {
    label: 'Bihar',
    value: 'Bihar',
  },
  {
    label: 'Chhattisgarh',
    value: 'Chhattisgarh',
  },
  {
    label: 'Goa',
    value: 'Goa',
  },
  {
    label: 'Gujarat',
    value: 'Gujarat',
  },

  {
    label: 'Haryana',
    value: 'Haryana',
  },
  {
    label: 'Himachal Pradesh',
    value: 'Himachal Pradesh',
  },
  {
    label: 'Jharkhand',
    value: 'Jharkhand',
  },
  {
    label: 'Karnataka',
    value: 'Karnataka',
  },
  {
    label: 'Madhya Pradesh',
    value: 'Madhya Pradesh',
  },
  {
    label: 'Manipur',
    value: 'Manipur',
  },
  {
    label: 'Meghalaya',
    value: 'Meghalaya',
  },
  {
    label: 'Mizoram',
    value: 'Mizoram',
  },
  {
    label: 'Nagaland',
    value: 'Nagaland',
  },
  {
    label: 'Odisha',
    value: 'Odisha',
  },
  {
    label: 'Rajasthan',
    value: 'Rajasthan',
  },
  {
    label: 'Sikkim',
    value: 'Sikkim',
  },
  {
    label: 'Tamil Nadu',
    value: 'Tamil Nadu',
  },
  {
    label: 'Telangana',
    value: 'Telangana',
  },
  {
    label: 'Tripura',
    value: 'Tripura',
  },
  {
    label: 'Uttar Pradesh',
    value: 'Uttar Pradesh',
  },
  {
    label: 'Uttarakhand',
    value: 'Uttarakhand',
  },
  {
    label: 'West Bengal',
    value: 'West Bengal',
  },
]

export const ageOfUser = [
  {
    label: '18',
    value: '18',
  },
  {
    label: '19',
    value: '19',
  },
  {
    label: '20',
    value: '20',
  },
  {
    label: '21',
    value: '21',
  },
  {
    label: '22',
    value: '22',
  },
  {
    label: '23',
    value: '23',
  },
  {
    label: '24',
    value: '24',
  },
]

export const genderArray = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: 'Other', label: 'Other' },
]
